export var EXIT_INTENT = 'exitIntent';
export var EXIT_INTENT_MOBILE = 'exitIntent';
export var TRUST_PULSE = 'trustPulse';
